import React from 'react';

import FormItemCon from "./../../../Components/Common/FormItem";

// Form 表单的 Item 外层包围样式及标签的定制
function FormItem(props) {

    return (
        <FormItemCon
            itemDOM={
                (
                    meta,
                    label,
                    extra,
                    fieldName,
                    childNode,
                    errorsText,
                    renderMeta,
                    requiredClear
                ) => (
                    <div className={`form-item ${props.className || fieldName}`}>
                        {/* props.requiredClear Web中可以使用::before样式定义是否有 * 号，此处可酌情调整 */}
                        <span className={requiredClear ? {} : ""} htmlFor={fieldName}>{label}</span>
                        <div className="">
                            <div className={errorsText.length > 0 && "error-input-reference"} />
                            {childNode}
                            {
                                errorsText.map((v, i) => (
                                    <span key={i} htmlFor={fieldName} className="error-text">{v}</span>
                                ))
                            }
                            {renderMeta && renderMeta(meta)}
                            {extra ? extra : null}
                        </div>
                    </div>
                )
            }
            {...props}
        />
    )
}


export default FormItem;
